<template>
  <Teleport to="body">
    <div class="modal-overlay" :style="{ zIndex }" @click.self="$emit('fechar')">
      <div class="modal-mapa-container">
        <!-- Header -->
        <div class="modal-mapa-header">
          <h5 class="mb-0">Mapa de Menus</h5>
          <button class="btn-close" @click="$emit('fechar')"></button>
        </div>

        <!-- Toggle Interno -->
        <div class="modal-mapa-tabs">
          <button class="btn" :class="abaAtiva === 'mapa' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="abaAtiva = 'mapa'">
            <i class="bi bi-map"></i> Mapa Completo
          </button>
          <button class="btn" :class="abaAtiva === 'favoritos' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="abaAtiva = 'favoritos'">
            <i class="bi bi-star-fill"></i> Gerenciar Favoritos
          </button>
        </div>

        <!-- Busca no Mapa -->
        <div class="modal-mapa-search" v-if="abaAtiva === 'mapa'">
          <!-- Switch de Busca Avançada -->
          <div class="form-check form-switch mb-2">
            <input class="form-check-input" type="checkbox" role="switch"
                   id="buscaAvancadaSwitch" v-model="buscaAvancadaAtiva">
            <label class="form-check-label" for="buscaAvancadaSwitch">
              <i class="bi bi-search-plus"></i> Busca Avançada
              <small class="text-muted">(contexto de negócio + palavras-chave)</small>
            </label>
          </div>

          <!-- Input de busca simples -->
          <div class="input-group" v-if="!buscaAvancadaAtiva">
            <input type="text" class="form-control" placeholder="Filtrar no mapa..."
                   v-model="filtroMapa">
            <button v-if="filtroMapa && filtroMapa.length > 0"
                    class="input-group-text"
                    @click="filtroMapa = ''" title="Limpar busca"
                    style="cursor: pointer;">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <!-- Input + Botão Pesquisar (busca avançada) -->
          <div class="input-group" v-else>
            <input type="text" class="form-control" placeholder="Digite o termo e pressione Enter ou Pesquisar..."
                   v-model="filtroMapa" @keyup.enter="executarBuscaAvancada">
            <button v-if="filtroMapa && filtroMapa.length > 0"
                    class="input-group-text"
                    @click="filtroMapa = ''; resultadosAvancados = []; buscaRealizada = false"
                    title="Limpar busca"
                    style="cursor: pointer;">
              <i class="bi bi-x-lg"></i>
            </button>
            <button class="btn btn-primary" @click="executarBuscaAvancada"
                    :disabled="!filtroMapa || filtroMapa.length === 0">
              <i class="bi bi-search"></i> Pesquisar
            </button>
          </div>

          <small v-if="buscaAvancadaAtiva && resultadosAvancados.length > 0" class="text-success d-block mt-1">
            <i class="bi bi-check-circle"></i> {{ resultadosAvancados.length }} resultado(s) encontrado(s)
          </small>
          <small v-if="buscaAvancadaAtiva && filtroMapa && filtroMapa.length > 0 && resultadosAvancados.length === 0 && buscaRealizada" class="text-warning d-block mt-1">
            <i class="bi bi-exclamation-triangle"></i> Nenhum resultado encontrado para "{{ filtroMapa }}"
          </small>
        </div>

        <!-- Conteúdo: Mapa Completo -->
        <div v-if="abaAtiva === 'mapa'" class="modal-mapa-content">
          <div class="mapa-grid">
            <div v-for="group in gruposFiltrados" :key="group.id" class="mapa-coluna">
              <h6 class="mapa-grupo-titulo">
                <i :class="['bi', group.icon, 'me-1']"></i>
                {{ group.label }}
                <span class="mapa-grupo-contagem">{{ group.items.filter(i => !i.isHeader).length }}</span>
              </h6>
              <div v-for="(item, idx) in group.items" :key="item.module || item.title"
                   :class="['mapa-item', { 'mapa-item-sub': isItemInSubgroup(group, idx) }]">
                <template v-if="item.isHeader">
                  <span class="mapa-header-text">{{ item.title }}</span>
                </template>
                <template v-else>
                  <span class="mapa-estrela" @click="toggleFavorito(item)" :title="isFavoritoLocal(item) ? 'Remover dos favoritos' : 'Adicionar aos favoritos'">
                    <i :class="isFavoritoLocal(item) ? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
                  </span>
                  <a href="#" class="mapa-link" @click.prevent="navegar(item)">
                    <i :class="['bi', item.icon, 'me-1']"></i>
                    {{ item.title }}
                  </a>
                </template>
              </div>
            </div>
          </div>
          <div class="mapa-footer" v-if="resultadosBusca > 0">
            <small class="text-muted">{{ resultadosBusca }} resultados em {{ gruposFiltrados.length }} grupos</small>
          </div>
          <div class="mapa-footer" v-else-if="filtroMapa && filtroMapa.length > 0">
            <small class="text-muted">Nenhum resultado encontrado para '{{ filtroMapa }}'</small>
          </div>
        </div>

        <!-- Conteúdo: Gerenciar Favoritos -->
        <div v-else class="modal-mapa-content split-view">
          <div class="split-left">
            <h6 class="mb-2">Seus Favoritos</h6>
            <p class="text-muted small" v-if="favoritosInternos.length > 0">Arraste para reordenar</p>
            <div v-if="favoritosInternos.length === 0" class="text-muted text-center py-4">
              <i class="bi bi-star fs-1 d-block mb-2"></i>
              <p>Nenhum favorito ainda. Use o Mapa para adicionar.</p>
            </div>
            <ul v-else class="lista-favoritos">
              <li v-for="(fav, idx) in favoritosInternos" :key="fav.idRegraAcesso"
                  :class="{ 'selecionado': favoritoSelecionado === idx, 'dragging': dragIndex === idx }"
                  @click="selecionarFavorito(idx)"
                  draggable="true"
                  @dragstart="onDragStart($event, idx)"
                  @dragover="onDragOver($event)"
                  @drop="onDrop($event, idx)"
                  class="favorito-item">
                <span class="drag-handle"><i class="bi bi-grip-vertical"></i></span>
                <span class="favorito-info">
                  <i :class="['bi', obterIcone(fav), 'me-1']"></i>
                  <span>{{ fav.descricao || fav.chave }}</span>
                  <small class="text-muted d-block">{{ obterGrupo(fav) }}</small>
                </span>
                <button class="btn btn-sm btn-link text-danger" @click.stop="removerFavorito(idx)"
                        title="Remover dos favoritos">
                  <i class="bi bi-x-lg"></i>
                </button>
              </li>
            </ul>
            <div class="mt-2 d-flex gap-2">
              <button class="btn btn-sm btn-outline-primary" @click="abaAtiva = 'mapa'">
                <i class="bi bi-plus-circle"></i> Adicionar do Mapa
              </button>
              <button class="btn btn-sm btn-success" @click="salvarOrdem" :disabled="!houveAlteracao">
                <i class="bi bi-floppy"></i> Salvar Ordem
              </button>
            </div>
          </div>
          <div class="split-right">
            <div v-if="favoritoSelecionado !== null && favoritosInternos[favoritoSelecionado]" class="descricao-painel">
              <h6>{{ favoritosInternos[favoritoSelecionado].descricao || favoritosInternos[favoritoSelecionado].chave }}</h6>
              <p class="text-muted small">Chave: {{ favoritosInternos[favoritoSelecionado].chave }}</p>
              <p class="text-muted small">Módulo: {{ favoritosInternos[favoritoSelecionado].modulo }}</p>
              <button class="btn btn-primary btn-sm" @click="navegarFavorito(favoritosInternos[favoritoSelecionado])">
                <i class="bi bi-box-arrow-up-right"></i> Abrir Tela
              </button>
            </div>
            <div v-else class="text-muted text-center py-4">
              <p>Selecione um favorito para ver detalhes</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import api from '@/services/api'
import { useMenuPermissao } from '@/composables/useMenuPermissao'
import { useFavoritos } from '@/composables/useFavoritos'
import { useUiStore } from '@/stores/ui'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

export default {
  name: 'ModalMapaMenus',
  props: {
    menuConfig: { type: Array, required: true },
    favoritos: { type: Array, required: true }
  },
  emits: ['fechar', 'show-notification', 'toggle-favorito'],
  setup (props, { emit }) {
    const uiStore = useUiStore()
    const { menuComFiltroRBAC, menuSearchIndex } = useMenuPermissao(props.menuConfig)
    const { salvarFavoritos } = useFavoritos()

    const isMobile = window.innerWidth < 768
    const abaAtiva = ref(isMobile ? 'favoritos' : 'mapa')
    const filtroMapa = ref('')
    const favoritoSelecionado = ref(null)
    const favoritosInternos = ref([...props.favoritos])
    const houveAlteracao = ref(false)
    const dragIndex = ref(null)
    const buscaAvancadaAtiva = ref(false)
    const resultadosAvancados = ref([])
    const buscaRealizada = ref(false)

    // --- Empilhamento (z-index) via registry central ---
    const zIndex = ref(BASE_ZINDEX)
    const tokenZIndex = ref(null)

    // Reserva síncrona no setup (o componente é criado via `v-if`),
    // evitando um frame na camada base antes do reserve.
    const reservaInicial = reservarZIndex()
    tokenZIndex.value = reservaInicial.token
    zIndex.value = reservaInicial.zIndex

    /**
     * Executa a busca avançada no backend.
     * Chama GET /api/RegrasAcesso/busca-avancada?termo=
     * e armazena os resultados em resultadosAvancados.
     */
    async function executarBuscaAvancada () {
      const termo = filtroMapa.value?.trim()
      if (!termo) return
      buscaRealizada.value = true
      try {
        const response = await api.get('/RegrasAcesso/busca-avancada', {
          params: { termo },
          _suppressLoading: true
        })
        resultadosAvancados.value = response.data || []
      } catch (e) {
        console.warn('[ModalMapaMenus] Erro na busca avançada:', e)
        resultadosAvancados.value = []
        emit('show-notification', {
          message: 'Erro ao realizar busca avançada.',
          type: 'error'
        })
      }
    }

    const gruposFiltrados = computed(() => {
      let grupos = menuComFiltroRBAC.value

      // Busca avançada: só filtra quando o usuário clicou em Pesquisar (resultadosAvancados populado)
      if (buscaAvancadaAtiva.value) {
        if (resultadosAvancados.value.length > 0 && filtroMapa.value?.length > 0) {
          const chavesMatch = new Set(resultadosAvancados.value.map(r => r.chave))
          grupos = grupos
            .map(group => {
              const itensFiltrados = group.items.filter(item =>
                !item.isHeader && chavesMatch.has(item.perm)
              )
              if (itensFiltrados.length === 0) return null
              const itensComHeaders = []
              for (let i = 0; i < group.items.length; i++) {
                const item = group.items[i]
                if (item.isHeader) {
                  const nextHeaderIdx = group.items.findIndex((it, idx) => idx > i && it.isHeader)
                  const slice = nextHeaderIdx === -1
                    ? group.items.slice(i + 1)
                    : group.items.slice(i + 1, nextHeaderIdx)
                  const hasVisible = slice.some(it => itensFiltrados.includes(it))
                  if (hasVisible) itensComHeaders.push(item)
                } else if (itensFiltrados.includes(item)) {
                  itensComHeaders.push(item)
                }
              }
              return { ...group, items: itensComHeaders }
            })
            .filter(group => group !== null && group.items.length > 0)
        }
        // Se não pesquisou ainda, mostra tudo (sem filtro)
        return [...grupos].sort((a, b) => a.items.length - b.items.length)
      }

      // Busca simples: filtra por título
      if (filtroMapa.value && filtroMapa.value.length > 0) {
        const termo = filtroMapa.value.toLowerCase()
        grupos = grupos
          .map(group => {
            const itensFiltrados = group.items.filter(item =>
              !item.isHeader && item.title.toLowerCase().includes(termo)
            )
            if (itensFiltrados.length === 0) return null
            const itensComHeaders = []
            for (let i = 0; i < group.items.length; i++) {
              const item = group.items[i]
              if (item.isHeader) {
                const nextHeaderIdx = group.items.findIndex((it, idx) => idx > i && it.isHeader)
                const slice = nextHeaderIdx === -1
                  ? group.items.slice(i + 1)
                  : group.items.slice(i + 1, nextHeaderIdx)
                const hasVisible = slice.some(it => itensFiltrados.includes(it))
                if (hasVisible) itensComHeaders.push(item)
              } else if (itensFiltrados.includes(item)) {
                itensComHeaders.push(item)
              }
            }
            return { ...group, items: itensComHeaders }
          })
          .filter(group => group !== null && group.items.length > 0)
      }

      // Ordenar por quantidade de itens (crescente)
      return [...grupos].sort((a, b) => a.items.length - b.items.length)
    })

    const resultadosBusca = computed(() => {
      if (!filtroMapa.value || filtroMapa.value.length === 0) return 0
      return gruposFiltrados.value.reduce((acc, g) => acc + g.items.filter(i => !i.isHeader).length, 0)
    })

    /**
     * Verifica se um item do grupo está dentro de um subgrupo (após algum isHeader).
     * Itens antes do primeiro header não são indentados; todos os demais sim.
     */
    const isItemInSubgroup = (group, idx) => {
      if (!group || !group.items || group.items[idx]?.isHeader) return false
      for (let i = 0; i < idx; i++) {
        if (group.items[i].isHeader) return true
      }
      return false
    }

    /**
     * Verifica localmente se um item do menu está nos favoritosInternos.
     * Usa a chave (item.perm) para comparar com favoritosInternos[].chave.
     */
    const isFavoritoLocal = (item) => {
      return favoritosInternos.value.some(f => f.chave === item.perm)
    }

    const toggleFavorito = (item) => {
      // Encontra o idRegraAcesso correspondente via menuSearchIndex.perm
      const idxExistente = favoritosInternos.value.findIndex(f => f.chave === item.perm)
      if (idxExistente !== -1) {
        // Remove
        favoritosInternos.value.splice(idxExistente, 1)
        houveAlteracao.value = true
      } else {
        // Adiciona — faz lookup de idRegraAcesso via menuSearchIndex.perm
        const menuItem = menuSearchIndex.value.find(m => m.perm === item.perm)
        if (!menuItem || !menuItem.idRegraAcesso) {
          emit('show-notification', {
            message: 'Não foi possível adicionar favorito: item sem idRegraAcesso.',
            type: 'error'
          })
          return
        }
        favoritosInternos.value.push({
          idRegraAcesso: menuItem.idRegraAcesso,
          chave: item.perm,
          descricao: item.title,
          modulo: item.group || '',
          ordem: favoritosInternos.value.length + 1
        })
        houveAlteracao.value = true
      }
      // Emite para o pai persistir imediatamente no backend
      emit('toggle-favorito', {
        favoritos: favoritosInternos.value.map((f, idx) => ({
          idRegraAcesso: f.idRegraAcesso,
          ordem: f.ordem || idx + 1
        }))
      })
    }

    const navegar = (item) => {
      uiStore.selecionarModulo(item.module, item.title, item.perm ? [item.perm] : [], item.extraProps || {})
      emit('fechar')
    }

    const selecionarFavorito = (idx) => {
      favoritoSelecionado.value = idx
    }

    const removerFavorito = (idx) => {
      favoritosInternos.value.splice(idx, 1)
      houveAlteracao.value = true
      if (favoritoSelecionado.value === idx) {
        favoritoSelecionado.value = null
      }
    }

    /**
     * Inicia o drag de um item da lista de favoritos.
     */
    const onDragStart = (event, index) => {
      dragIndex.value = index
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/plain', String(index))
    }

    /**
     * Permite o drop sobre um item da lista.
     */
    const onDragOver = (event) => {
      event.preventDefault()
      event.dataTransfer.dropEffect = 'move'
    }

    /**
     * Conclui o drop: move o item arrastado para a nova posição.
     */
    const onDrop = (event, index) => {
      event.preventDefault()
      const fromIndex = dragIndex.value
      if (fromIndex === null || fromIndex === index) return
      const item = favoritosInternos.value.splice(fromIndex, 1)[0]
      favoritosInternos.value.splice(index, 0, item)
      houveAlteracao.value = true
      dragIndex.value = null
    }

    const salvarOrdem = async () => {
      try {
        await salvarFavoritos(favoritosInternos.value)
        houveAlteracao.value = false
        emit('show-notification', { message: 'Ordem dos favoritos salva com sucesso!', type: 'success' })
      } catch (e) {
        emit('show-notification', { message: 'Erro ao salvar ordem dos favoritos.', type: 'error' })
      }
    }

    const navegarFavorito = (fav) => {
      const item = menuSearchIndex.value.find(m => m.perm === fav.chave)
      if (item) {
        uiStore.selecionarModulo(item.module, item.title, item.perm ? [item.perm] : [], item.extraProps || {})
        emit('fechar')
      }
    }

    const obterIcone = (fav) => {
      const item = menuSearchIndex.value.find(m => m.perm === fav.chave)
      return item?.icon || 'bi-star'
    }

    const obterGrupo = (fav) => {
      const item = menuSearchIndex.value.find(m => m.perm === fav.chave)
      return item?.group || fav.modulo || ''
    }

    onMounted(() => {
      // A busca avançada é feita no backend via /busca-avancada
    })

    onUnmounted(() => {
      liberarZIndex(tokenZIndex.value)
      tokenZIndex.value = null
    })

    return {
      abaAtiva,
      filtroMapa,
      buscaAvancadaAtiva,
      resultadosAvancados,
      buscaRealizada,
      zIndex,
      executarBuscaAvancada,
      favoritoSelecionado,
      favoritosInternos,
      houveAlteracao,
      dragIndex,
      gruposFiltrados,
      resultadosBusca,
      isItemInSubgroup,
      isFavoritoLocal,
      toggleFavorito,
      navegar,
      selecionarFavorito,
      removerFavorito,
      onDragStart,
      onDragOver,
      onDrop,
      salvarOrdem,
      navegarFavorito,
      obterIcone,
      obterGrupo
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 5vh;
}

.modal-mapa-container {
  background: var(--bs-body-bg);
  width: min(1600px, 95vw);
  max-width: 95vw;
  max-height: 90vh;
  height: auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}

.modal-mapa-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--bs-border-color);
}

.modal-mapa-tabs {
  display: flex;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid var(--bs-border-color);
}

.modal-mapa-search {
  padding: 0.75rem 1.5rem;
}

.modal-mapa-content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 1.5rem;
}

.mapa-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1.5rem;
}

.mapa-coluna {
  min-width: 0;
  background: var(--bs-tertiary-bg);
  border-radius: 0.5rem;
  padding: 0.75rem;
  border: 1px solid var(--bs-border-color-translucent);
  transition: background-color 0.2s ease;
}

.mapa-coluna:hover {
  background: var(--bs-secondary-bg);
}

.mapa-grupo-titulo {
  font-size: 0.8rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  padding-bottom: 0.35rem;
  border-bottom: 2px solid var(--bs-primary);
  color: var(--bs-body-emphasis);
}

.mapa-grupo-titulo i {
  color: var(--bs-primary);
  font-size: 1rem;
}

.mapa-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.4rem;
  font-size: 0.85rem;
  border-radius: 0.25rem;
  transition: background-color 0.15s ease;
}

.mapa-item:hover {
  background: var(--bs-secondary-bg);
}

.mapa-item-sub {
  padding-left: 1.25rem;
}

.mapa-estrela {
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.mapa-estrela:hover {
  transform: scale(1.3);
}

.mapa-estrela:active {
  transform: scale(0.9);
}

.mapa-link {
  text-decoration: none;
  color: var(--bs-body-color);
  flex: 1;
}

.mapa-link:hover {
  color: var(--bs-primary);
}

.mapa-header-text {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--bs-secondary-color);
  padding: 0.5rem 0 0.25rem 0;
  display: block;
}

.mapa-footer {
  padding: 0.5rem 0;
  text-align: center;
}

.split-view {
  display: flex;
  gap: 1.5rem;
}

.split-left {
  flex: 1;
  min-width: 300px;
}

.split-right {
  flex: 1;
  min-width: 300px;
  border-left: 1px solid var(--bs-border-color);
  padding-left: 1.5rem;
}

@media (max-width: 767.98px) {
  .split-view {
    flex-direction: column;
  }

  .split-left,
  .split-right {
    min-width: 0;
    width: 100%;
  }

  .split-right {
    border-left: none;
    border-top: 1px solid var(--bs-border-color);
    padding-left: 0;
    padding-top: 1rem;
  }
}

@media (max-width: 575.98px) {
  .modal-mapa-container {
    max-height: 95vh;
    border-radius: 8px;
  }

  .modal-mapa-content {
    padding: 0.75rem;
  }
}

.lista-favoritos {
  list-style: none;
  padding: 0;
  margin: 0;
}

.favorito-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
}

.favorito-item:hover,
.favorito-item.selecionado {
  background: var(--bs-tertiary-bg);
}

.drag-handle {
  cursor: grab;
  color: var(--bs-secondary-color);
}

.favorito-item.dragging {
  opacity: 0.5;
}

.favorito-item.drag-over {
  border-top: 2px solid var(--bs-primary);
}

.favorito-info {
  flex: 1;
}

.descricao-painel {
  padding: 1rem;
}

.mapa-grupo-contagem {
  font-size: 0.65rem;
  color: var(--bs-secondary-color);
  background: var(--bs-body-bg);
  padding: 0.05rem 0.35rem;
  border-radius: 1rem;
  margin-left: 0.4rem;
  vertical-align: middle;
}
</style>
